import axios from "axios";
// import { Navigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_SOCKET_URL;
// console.log("API Base URL:", apiUrl);

const axiosInstance = axios.create({
  baseURL: apiUrl + "/api",
  headers: {
    "Content-Type": "application/json", // ✅ Very important
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    const { code, message, data } = response.data || {};
    return {
      code: code || 500,
      message: message || "Something went wrong",
      data: data || null,
    };
  },
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
